export type ReportFormTypeZero = 0;
export type ReportFormTypeOne = 1;
export type ReportFormTypeTwo = 2;
export type ReportFormTypeThree = 3;
export type ReportFormTypeFour = 4;
export type ReportFormTypeFive = 5;
export type ReportFormTypeEoOne = 6;
export type ReportFormTypeEoOneAAssets = 7;
export type ReportFormTypeEoOneALiabilities = 8;
export type ReportFormTypeEoOneB = 9;
export type ReportFormTypeEoTen = 10;
export type ReportFormTypeOneThroughFour = ReportFormTypeOne | ReportFormTypeTwo | ReportFormTypeThree | ReportFormTypeFour;
export type ReportFormType = ReportFormTypeZero | ReportFormTypeOneThroughFour | ReportFormTypeFive;
export type ReportFormTypeEo = ReportFormTypeEoOne | ReportFormTypeEoOneAAssets | ReportFormTypeEoOneALiabilities | ReportFormTypeEoOneB | ReportFormTypeEoTen;

export const FormTypeId = {
  FormZero: 0,
  FormOne: 1,
  FormOneA: '1a',
  FormOneB: '1b',
  FormTwo: 2,
  FormThree: 3,
  FormFour: 4,
  FormFive: 5,
  FormEoOne: 6,
  FormEoOneAAssets: 7,
  FormEoOneALiabilities: 8,
  FormEoOneB: 9,
  FormTen: 10,
  FormEleven: 11,
  FormTwelve: 12,
  FormThirteen: 13,
  FormFourteen: 14,
  FormFifteen: 15,
  FormSixteen: 16,
  FormSeventeen: 17,
  FormEighteen: 18,
  FormNineteen: 19,
  FormOneThroughFour: (id: number): id is ReportFormTypeOneThroughFour => OneThroughFourFormTypes.includes(id as (typeof OneThroughFourFormTypes)[number]),
  isEconomyAopForm: (id: number): id is ReportFormTypeEo => EoAopFormTypes.includes(id as (typeof EoAopFormTypes)[number])
} as const;

export const OneThroughFourFormTypes = [
  FormTypeId.FormOne,
  FormTypeId.FormTwo,
  FormTypeId.FormThree,
  FormTypeId.FormFour
] as const;

export const EoAopFormTypes = [
  FormTypeId.FormEoOne,
  FormTypeId.FormEoOneAAssets,
  FormTypeId.FormEoOneALiabilities,
  FormTypeId.FormEoOneB
] as const;

export const DecimalScaleFormTypes = [
  FormTypeId.FormTen,
  FormTypeId.FormEleven,
  FormTypeId.FormTwelve,
  FormTypeId.FormThirteen,
  FormTypeId.FormFourteen,
  FormTypeId.FormFifteen
] as const;

export type DecimalScaleFormType = (typeof DecimalScaleFormTypes)[number];

export const EoFormThreeTotalId = 15;
